module.exports = __webpack_public_path__ + "static/media/background5.4bf09eba.png";